import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { IStocksList } from "interfaces/stocks";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_STOCKS_MOVEMENT" }
);

export interface PaginateStockMovementState extends IState {
  data: IStocksList[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateStockMovementState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateStockMovementState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateStockMovementState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateStockMovementState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateStockMovement = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateStockMovementTypes = Types;
export const PaginateStockMovementActions = Creators;
